export default {
  newDesign: true,
  title: "Çocuğunuz için kişisel teşhis randevusu alın | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  parameters: {
    landing_id: "TrLitSoft",
    segment: 46,
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      title: "Çocuğunuz kaç yaşında?",
      subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz.",
      type: "age",
      button: "",
    },
    2: {
      title: "Çocuğunuz için kişisel teşhis randevusu alın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    3: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    4: {
      title:
        "Teşekkür ederiz! 1-1 veli toplantısı için başarıyla rezervasyon yaptınız 🎉",
      typeInfo: "pc-laptop",
      subtitle:
        "Çocuğunuzun matematikte yaşadığı zorlukların üstesinden gelmesine ve sınavlara hazır olmasına yardımcı olmaktan mutluluk duyacağız. Hepsini eğlenerek yapacağız!",
      button: "Harika!",
    }
  },
};
